import { useDispatch, useSelector } from 'react-redux';
import './BulkTransactionsForm.css';
import { changeBulkTransactionAmount, changeFormActive, changeTransactionMode, selectBulkTransactionAmount, selectBulkTransactionFormActive, selectBulkTransactionMode } from './bulkTransactionsSlice';
import { selectAccounts } from '../manageAccounts/accountsSlice';
import { addTransactionPending, addTransactions, confirmingBulkTransaction, selectNewTransaction, selectTransactionError, setConfirmingBulkTransaction } from '../transactionList/transactionsSlice';
import { selectToken } from '../login/loginSlice';
import ConfirmAction from '../../components/confirmAction/ConfirmAction';

export default function BulkTransactionsForm({accountsCheckboxes}) {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const formActive = useSelector(selectBulkTransactionFormActive);
    const display = formActive ? "flex" : "none";

    const formMode = useSelector(selectBulkTransactionMode);
    const transactionAmount = useSelector(selectBulkTransactionAmount);

    const accounts = useSelector(selectAccounts);
    const newTransaction = useSelector(selectNewTransaction);
    const transactionError = useSelector(selectTransactionError);

    const transactionPending = useSelector(addTransactionPending);
    const confirmingAction = useSelector(confirmingBulkTransaction);

    const handleModeSelectorClick = (event) => {
        event.preventDefault();
        dispatch(changeTransactionMode(event.target.value));
    }

    const handleAmountChange = (event) => {
        dispatch(changeBulkTransactionAmount(event.target.value));
    }

    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(changeFormActive(false));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(setConfirmingBulkTransaction(true));
    }

    const handleConfirmCancelClick = () => {
        dispatch(setConfirmingBulkTransaction(false));
    }

    const handleConfirmBulkTransaction = () => {
        let newTransactions = [];
        accountsCheckboxes.forEach(checkbox => {
            if (checkbox.value) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
                const day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1;
                const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
                const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes() ;
                const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
                const transactionDate = `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;

                const description = formMode === "deposit" ? `Teller Deposit` : `Teller Withdrawal`;
                newTransactions.push({
                    accountId: checkbox.accountId,
                    type: formMode === "deposit" ? 'credit' : 'debit',
                    description,
                    amount: transactionAmount,
                    transactionDate
                })
            }
        });
        dispatch(addTransactions({transactions: newTransactions, token}));
        dispatch(setConfirmingBulkTransaction(false));
    }

    return (
        <form className="form" style={{display: display, flexDirection: 'column'}}>
            <h2>Bulk Transactions</h2>
            <div className='mode-selector'>
                <button id='selector' 
                    value="deposit" 
                    onClick={handleModeSelectorClick} 
                    style={formMode === 'deposit' ? {backgroundColor: 'darkslategray', color: 'rgb(97, 185, 196)'} : {}}>Deposit</button>
                <button 
                    id='selector' 
                    value="withdraw" 
                    onClick={handleModeSelectorClick} 
                    style={formMode === 'withdraw' ? {backgroundColor: 'darkslategray', color: 'rgb(97, 185, 196)'} : {}}>Withdraw</button>
            </div>
            <label>
                <h3>Amount:</h3>
                <div className='amount-field'>
                    <p className='dollar-sign'>$</p>
                    <input placeholder='0.00' value={transactionAmount} onChange={handleAmountChange}></input>
                </div>
            </label>
            <h3>Selected Accounts</h3>
            {transactionError ? <p>{transactionError}</p> : newTransaction.length > 0 ? <p className='confirmation'>Transactions created successfully.</p> : ""}
            <table>
                <thead>
                    <tr>
                        <th>Account Number</th>
                        <th>User Id</th>
                        <th>Account Type</th>
                        <th>Current Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {accountsCheckboxes.map(checkbox => {
                        if (checkbox.value) {
                            return (
                                <tr>
                                    <td>{checkbox.accountId}</td>
                                    <td>{accounts[checkbox.accountId].username}</td>
                                    <td>{accounts[checkbox.accountId].accountType}</td>
                                    <td>${accounts[checkbox.accountId].balance.toFixed(2)}</td>
                                </tr> 
                            )
                        } else {
                            return "";
                        }
                    })}
                </tbody>
            </table>
            <div className='button-container'>
                <button onClick={handleCancelButtonClick} disabled={transactionPending}>Cancel</button>
                <button onClick={handleSubmit} disabled={transactionPending}>{transactionPending ? 'Processing...' : 'Submit'}</button>
            </div>
             {confirmingAction ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmBulkTransaction}/> : ""}
        </form>
    )
}